import React from 'react';

export function ForgotPassword(){
    return (
        <div>Forgot password</div>
    )
}